import React from 'react';

import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';

/**
 * プロパティ
 */
export type Props = {
  /** 名前 */
  name: string,
  /** コンテント */
  content: string | undefined,
  /** セカンダリ */
  secondary?: string | undefined,
};

const CustomListItem: React.FC<Props> = ({ name, content, secondary }) => (
  <ListItem>
    <ListItemIcon style={{ minWidth: '100px' }}>{name}</ListItemIcon>
    <List>
      <ListItemText primary={content} secondary={secondary} />
    </List>
  </ListItem>
);

export default CustomListItem;
